import { FontAwesome5 } from '@expo/vector-icons';
import { debounce } from '@openeducation/oe-rn-services';
import { styled } from '@openeducation/oe-rn-themes';
import React, { useState, useEffect } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useTheme } from 'react-native-paper';

import { flex } from '../../style-utils';

export interface SearchInputProps {
  onSearch: (value: string) => void;
  iconColor?: string;
  style?: StyleProp<ViewStyle>;
  placeholder?: string;
  disabled?: boolean;
}

export const SearchInput = ({
  onSearch,
  iconColor,
  style,
  placeholder,
  disabled = true,
}: SearchInputProps) => {
  const [value, setValue] = useState<string>('');
  const { colors } = useTheme();

  const handleSearch = debounce(() => {
    onSearch(value);
  }, 300);

  useEffect(() => {
    handleSearch();
  }, [value, handleSearch]);

  const iconColorState = disabled ? colors.border : iconColor;

  return (
    <View style={[flex('flex-1')]}>
      <LoupeIcon color={iconColorState} />
      <StyledSearchInput
        value={value}
        onChangeText={setValue}
        onEndEditing={handleSearch}
        autoCapitalize="words"
        autoCorrect={false}
        style={style}
        placeholder={placeholder}
        editable={!disabled}
        selectTextOnFocus={!disabled}
      />
      {value && (
        <ClearIcon onPress={() => setValue('')} color={iconColorState} />
      )}
    </View>
  );
};

const INPUT_HEIGHT = 38;

const LoupeIcon = styled(FontAwesome5).attrs(({ theme, color }) => ({
  color: color || theme.color.primary,
  width: 14,
  height: 16,
  name: 'search',
}))`
  position: absolute;
  top: 13px;
  left: 21px;
`;
const ClearIcon = styled(FontAwesome5).attrs(({ theme, color }) => ({
  color: color || theme.color.primary,
  width: 14,
  height: 16,
  name: 'times',
}))`
  position: absolute;
  top: 13px;
  right: 16px;
`;

const StyledSearchInput = styled.TextInput.attrs(({ theme }) => ({
  placeholderTextColor: theme.color.dark3,
}))`
  height: ${INPUT_HEIGHT}px;
  border-color: ${({ theme }) => theme.color.primary};
  border-width: 1px;
  border-radius: ${INPUT_HEIGHT / 2}px;
  padding-left: 46px;
  padding-right: 20px;
`;

export default SearchInput;
